import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsContainer from "@/components/CardsContainer";
import CardsList from "@/components/CardsList";
import CardsTable from "@/components/CardsTable";
import VLFModal from "@/components/Modal";

import {ModuleAPI} from "@/api/module";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {ERROR_OPERATION, SUCCESSFUL_OPERATION} from "@/utils/constants";

import "./index.scss";

function SettingsModulesPage(props) {
	const {handleNotification} = props;
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const [modules, setModules] = useState([]);
	const [openHandleConfirm, setOpenHandleConfirm] = useState(false);
	const [selectedId, setSelectedId] = useState(null);

	const getModules = async () => {
		setLoading(true);
		try {
			const response = await ModuleAPI.list();
			setModules(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	const deleteModule = async () => {
		setLoading(true);
		try {
			await ModuleAPI.delete(selectedId);
			setOpenHandleConfirm(false);
			getModules();
			handleNotification(SUCCESSFUL_OPERATION, "success");
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
			setLoading(false);
		}
	};

	useEffect(() => {
		getModules();
	}, []);

	const listConfiguration = {
		data: modules,
		onClick: (mod) => navigate("/settings/modules/" + mod.id),
		title: (mod) => mod.name,
		subtext: (mod) =>
			`D: ${mod.defenders ?? "-"}  M: ${mod.defensiveMidfielders ?? "-"}  C: ${mod.centralMidfielders ?? "-"}  T: ${mod.attackingMidfielders ?? "-"}  A: ${mod.attackers ?? "-"}`,
		actions: [
			{
				icon: <EditIcon />,
				variant: "outlined",
				title: "Modifica",
				onClick: (mod) => navigate("/settings/modules/" + mod.id + "/edit"),
			},
			{
				icon: <DeleteIcon />,
				variant: "outlined",
				title: "Elimina",
				onClick: (mod) => {
					setSelectedId(mod.id);
					setOpenHandleConfirm(true);
				},
				color: "error",
			},
		],
	};

	const columns = [
		{label: "Nome", key: "name", align: "start"},
		{label: "Difensori", key: "defenders"},
		{label: "Mediani", key: "defensiveMidfielders"},
		{label: "Centrocampisti", key: "centralMidfielders"},
		{label: "Trequartisti", key: "attackingMidfielders"},
		{label: "Attaccanti", key: "attackers"},
	];

	const mainActions = [
		{
			icon: <AddIcon />,
			title: "Nuovo modulo",
			onClick: () => navigate("/settings/modules/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				current="Moduli"
				actions={<MainActions actions={mainActions} />}
			/>
			<CardsContainer
				tableComponent={
					<CardsTable
						breadcrumbs
						configurationColumns={columns}
						data={modules}
						fullWidth
						handleClick={(item) => navigate("/settings/modules/" + item.id)}
						handleEdit={(item) =>
							navigate("/settings/modules/" + item.id + "/edit")
						}
						handleDelete={(item) => {
							setSelectedId(item.id);
							setOpenHandleConfirm(true);
						}}
						defaultSortedField="name"
					/>
				}
				listComponent={
					<CardsList
						type="users"
						breadcrumbs
						listConfiguration={listConfiguration}
						defaultSortedField="name"
					/>
				}
			/>
			<VLFModal
				open={openHandleConfirm}
				title="Eliminazione"
				content={
					<div className="mt-2">
						Sei sicuro di voler eliminare questo elemento?
					</div>
				}
				confirm={() => deleteModule()}
				close={() => setOpenHandleConfirm(false)}
				confirmLabel="Conferma"
			/>
		</Page>
	);
}

export default SettingsModulesPage;
